'use strict';

const page = require('../../page');
const giftCardUtils = require('./giftCardUtils');
const gtm = require('../../modules/google').tagManager;

const pgminicart = {
    init: function (minicart) {
        initRemoving(minicart);
        giftCardUtils.init();
    }
};

function initRemoving(minicart){
    if (!minicart) {
        return;
    }
    $(document).off('click.pgminicart');
    $(document).on('click.pgminicart', '.js-pg-minicart-remove', function(e) {
        e.preventDefault();
        const $this = $(this);
        $.ajax({
            url: Urls.removeProductFromCart,
            type: 'POST',
            data: {
                productId: $this.data('product-id'),
                editMode: $('.js-edit-mode-indicator').val() || window.pageContext.type === 'Cart'
            },
            dataType: 'json'
        }).done(function (response) {
            if (response.success) {
                if (response.reload) {
                    page.refresh();
                    return;
                }
                const $product = $this.parents('.mini-cart-product');
                $product.remove();

                minicart.updateProductsAndPrice(response.totalPrice, response.numberOfProducts, 0);
                minicart.updateHeaderCartIcon(response.numberOfProducts);

                if (response.numberOfProducts === 0) {
                    minicart.switchToEmptyCart();
                }

                const customizableSet = $this.data('data-layer-products');
                if (customizableSet) {
                    gtm.updateQuantity('remove_from_cart', customizableSet);
                }
            }
        }).fail(function() {
            window.alert(Resources.BAD_RESPONSE);
        });
    });
}

module.exports = pgminicart;
